import { render, staticRenderFns } from "./AddPlan.vue?vue&type=template&id=c8891906&scoped=true&"
import script from "./AddPlan.vue?vue&type=script&lang=js&"
export * from "./AddPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8891906",
  null
  
)

export default component.exports